import React from "react";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedPaymentMethod } from "../action";
import { is } from "../thunk";
import { PAYMENT_TYPES } from "../constant";

const Form = styled.form`
  margin: 2rem auto 0;
`;

const FormElm = styled.div`
  display: flex;
  align-items: center;
`;

const Label = styled.label`
  font-size: 13px;
  line-height: 19.5px;
  margin-left: 1rem;
  padding: 3px 0px;
  color: rgb(55, 58, 60);
  font-weight: normal;
`;

const Bold = styled.strong`
  font-weight: 700;
  margin-left: 1rem;
`;

const RoutingNum = styled.span`
  margin-left: 0.2rem;
`;

const RadioFormattedOptions = () => {
  const dispatch = useDispatch();
  const paymentMethods = useSelector((state) => state.paymentMethods);
  const { methods, selectedMethod } = paymentMethods;
  const selectedId = selectedMethod.id;
  const options = [
    ...methods.filter((method) =>
      is(method.paymentMethod, PAYMENT_TYPES.MAILCHECK_BULK)
    ),
    ...methods.filter(
      (method) =>
        is(method.paymentMethod, PAYMENT_TYPES.ACH_BULK) && method.verified
    ),
    ...methods.filter((method) =>
      is(method.paymentMethod, PAYMENT_TYPES.PAYPAL_ACCOUNT_BULK)
    ),
  ];
  const setPaymentMethod = (e, method) => {
    e.preventDefault();
    dispatch(setSelectedPaymentMethod(method));
  };

  const OptionsToDisplay = ({ method }) => (
    <FormElm>
      <Label htmlFor={method.id}>
        <input
          type="radio"
          value={method.id}
          id={method.id}
          checked={method.id === selectedId}
          onChange={(e) => setPaymentMethod(e, method)}
        />
        {is(method.paymentMethod, PAYMENT_TYPES.ACH_BULK) && (
          <>
            <Bold>Account {method.account.slice(2)}</Bold>{" "}
            <RoutingNum>Routing {method.routing.slice(-4)}</RoutingNum>
          </>
        )}
        {is(method.paymentMethod, PAYMENT_TYPES.MAILCHECK_BULK) && (
          <Bold>Mail Check</Bold>
        )}
        {is(method.paymentMethod, PAYMENT_TYPES.PAYPAL_ACCOUNT_BULK) && (
          <Bold>Account: {method.paypalAccountEmail}</Bold>
        )}
      </Label>
    </FormElm>
  );

  return (
    <Form>
      {options.map((method) => (
        <OptionsToDisplay key={method.id} method={method} />
      ))}
    </Form>
  );
};

RadioFormattedOptions.prototype = {};

export { RadioFormattedOptions };
